import { Construction } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface UnderConstructionProps {
    title?: string;
    message?: string;
}

const UnderConstruction: React.FC<UnderConstructionProps> = ({
    title = 'Page Under Construction',
    message = 'We are working hard to bring you this feature. Please check back later.'
}) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center bg-white rounded-xl border border-slate-200">
            <div className="w-16 h-16 bg-slate-100 text-slate-400 rounded-full flex items-center justify-center mb-6">
                <Construction size={32} />
            </div>

            <h2 className="text-xl font-bold text-slate-900 mb-2">
                {title}
            </h2>

            <p className="text-slate-500 mb-8 max-w-md">
                {message}
            </p>

            <button
                onClick={() => navigate(-1)}
                className="px-4 py-2 bg-white text-slate-700 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors font-medium text-sm"
            >
                Go Back
            </button>
        </div>
    );
};

export default UnderConstruction;
